// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wQXR","col":"styles_col__-qQYI"};